<template>
  <ul class="nav nav-pills tbOliver mb-3 mt-4" id="pills-tab" role="tablist">
    <li class="nav-item">
      <a
        class="nav-link active"
        id="pills-home-tab"
        data-toggle="pill"
        href="#pills-home"
        role="tab"
        aria-controls="pills-home"
        aria-selected="true"
      >
        <div class="titCard">
          <h4>Activity</h4>
        </div>
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        id="pills-profile-tab"
        data-toggle="pill"
        href="#pills-profile"
        role="tab"
        aria-controls="pills-profile"
        aria-selected="false"
      >
        <div class="titCard">
          <h4>Demo Links</h4>
        </div>
      </a>
    </li>
  </ul>
</template>

<script>
export default {};
</script>